// theme.js (MUI v5+)
import { createTheme } from "@mui/material/styles";

// ✅ رنگ‌ها بر اساس گاید برند راما به‌روزرسانی شدن
const colors = {
  primaryBlue: "#1E3A8A", // آبی سرمه‌ای (Primary)
  primaryOrange: "#FF6B35", // نارنجی (Accent fill & buttons)
  primaryOrangeText: "#C84813", // نارنجی تیره با کنتراست 4.62:1 جهت متن روی زمینه روشن
  secondarySky: "#0EA5E9", // آبی روشن (Secondary)
  primaryDark: "#0F172A", // خاکستری تیره (Text)

  infoBlue: "#0EA5E9",
  successGreen: "#00A63D",
  errorRed: "#FF3737",
  warningAmber: "#FFA411",
  neutralGray: "#556477", // کنتراست بهینه برای متن ثانویه

  cardBgGray: "rgba(30, 58, 138, 0.06)",
  hoverCardBgGray: "#F1F5F9",
  bgDefault: "#F8FAFC", // سفید نرم (Background)
  bgPaper: "#FFFFFF",
  iconBg: "#1E3A8A1A",
};

export const theme = createTheme({
  palette: {
    mode: "light",

    primary: { main: colors.primaryBlue, contrastText: "#FFFFFF" },
    secondary: {
      main: colors.primaryOrange,
      dark: colors.primaryOrangeText,
      contrastText: "#FFFFFF",
    },

    info: { main: colors.infoBlue, contrastText: "#FFFFFF" },
    success: { main: colors.successGreen, contrastText: "#FFFFFF" },
    warning: { main: colors.warningAmber, contrastText: "#1A1A1A" },
    error: { main: colors.errorRed, contrastText: "#FFFFFF" },

    text: { primary: colors.primaryDark, secondary: colors.neutralGray },
    divider: "#E6EAF0",

    background: {
      default: colors.bgDefault,
      paper: colors.bgPaper,
      card: colors.cardBgGray,
      hoverCard: colors.hoverCardBgGray,
      iconBg: colors.iconBg,
      black: "#090B10",
    },

    grey: {
      100: "#F8FAFC",
      200: "#EEF1F5",
      300: "#E0E4EA",
      400: "#BDC3CC",
      500: colors.neutralGray,
      800: colors.primaryDark,
    },
  },

  // ✅ کلی radius رو دست نزن
  // shape: { borderRadius: 12 },

  typography: {
    fontFamily: [
      "Dana",
      "YekanPlus",
      "Gaj2",
      "Inter",
      "IRANSans",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),

    h1: { fontFamily: "YekanPlus", fontWeight: 800 },
    h2: { fontFamily: "YekanPlus", fontWeight: 800 },
    h3: { fontFamily: "YekanPlus", fontWeight: 700 },
    h4: { fontFamily: "YekanPlus", fontWeight: 600 },
    h5: { fontFamily: "YekanPlus", fontWeight: 500 },
    h6: { fontFamily: "YekanPlus", fontWeight: 400 },

    body1: { fontFamily: "Dana", fontWeight: 400 },
    body2: { fontFamily: "Dana", fontWeight: 400 },

    button: { fontWeight: 700, textTransform: "none" },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        body: {
          scrollbarWidth: "thin",
          scrollbarColor: `${theme.palette.primary.main} transparent`,
        },
        "*::-webkit-scrollbar": { width: "6px" },
        "*::-webkit-scrollbar-track": { background: "transparent" },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.primary.main,
          borderRadius: "8px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      }),
    },

    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: { borderRadius: 0 },
        colorPrimary: { backgroundColor: colors.primaryBlue },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: `${theme.palette.warning.contrastText}40`,
          },
        }),
      },
    },
  },
});
